<template>
  <div class="word_pk_page">
    <div class="word_pk_set_words">
      <div class="word_pk_set_words-hd">
        <div class="navigation">
          <div class="left">
            <div style="display: none" class="back-btn" @click="backRoute"></div>
          </div>
          <div class="center" v-if="article">{{ article.ch_title }}-{{ article.chapters_en }}</div>
          <div class="right" style="margin-right: 7rem">
            <a href="javascript:;" class="ui-btn ui-btn_primary" @click="wancheng">完成</a>
          </div>
        </div>
      </div>
      <div class="word_pk_set_words-bd">
        <div class="items">
          <div class="items_item items_item_left">
            <div class="left_item" v-html="article.html_content"></div>
          </div>
          <div class="items_item items_item_right">
            <div class="right_item" v-html="article.html_translate"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="js_trans_alert">
      <div class="js_trans_alert_hd">
        <div class="title">word</div>
        <div class="icon">
          <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAXCAMAAAAvFN9lAAAAQlBMVEWP18uP38+O1ciO1siP1MmP18mO1chHcEyO1ciP18eP1siP1cmN1ciN1siO1siP1ciO1ciO1ciO1smO1ciN1MeP1snqld0xAAAAFXRSTlNAEN9/MGDwAMAgcICgkOBQz++vv7DRtMnEAAAAtElEQVQoz3XSS5bDIAxEUREDJfxNOnn732oP7LhNWmFG3QMHIZm6VW739LezngALsdzgxOXnigcdOMIkWR6GYWjtTQemCk1WAczoUQaz9rTH+ZElhxagwVPaYIxOrpAleEW4wSQ59wgbLJJDhIL5K9px7RqWAptU8QAbVCnDEmCqFGk604/XjlJ6sMpGd/f8728dytky8w4L+LXZbzZJarWmfkx23pPUPmdI5pC/DJikfDH9Ag6MH78wNRluAAAAAElFTkSuQmCC"
              alt="" class="icon-img">
        </div>
      </div>
      <div class="js_trans_alert_bd">
        <div class="trans">单词</div>
      </div>
      <div class="js_trans_alert_ft">
        <a class="ui-btn btn_view_word_detail" @click="alertWordDetail">
          <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAWlBMVEVHcEyM89+M89+L89+M9OCP/9+M9N+N89+M89+M9OCM8+CP99+K9N+M9d+L9N+M8+CM89+N8+CL9OGM89+M89+M9OCM8+CM8+GL89+O9eGM89+L896N89+N9OAUINAuAAAAHXRSTlMAoOBAfxBggMC/zyAwUJDf0J9f8LCP72/bT4jWcPG0R98AAAD5SURBVDjLrZPLkoQgEAQT3EYUndF57Lv+/zf3wBgKoeFl60oGZBPVALdOu+luAFivw/QG9JK/tDtxXuohSM7YjTkpEOUPzsG8ItKFwzgJqT0G2g0wvFWxCoj1iGMFhFglVcCpwykwdmXmU8lwIvmwf5EM8usTi90TSM+um7+AwXYk4fKqSwLWMRe7X5ykKUq62gZY00jTkOvidgGne1peNWrJAe56ZHKUGmrJdnNnUwBDrrKBV1x+YQsURWwA7Ko77JQ2Se8fRvMpfQMxT1t+8HazgjTXxOglST+ZmKTrvJY5L+zYtiHhpA5sKosyFL4+d2VzXi5ik/4Aszcmbvu969sAAAAASUVORK5CYII="
              alt="" class="icon-img">
          单词详解
        </a>
      </div>
    </div>
    <div id="mp3_list" style="display: none"></div>


    <a-modal
        @cancel="modalClose"
        :visible="modal_is_visible"
        width="600px"
        wrapClassName="translate-modal"
        :zIndex="1040"
        :forceRender="true"
        :centered="true"
        :footer="null"
    >
      <div class="translate-detail">
        <iframe ref="translateFrame" width="100%" :src="frameSrc" height="100%" frameborder="0"></iframe>
      </div>
    </a-modal>

  </div>
</template>
<script>
import { getFamousChapter, searchWord } from '../../services'
import { Modal } from 'ant-design-vue'

export default {
  name: 'famous_read_book',
  components: {
    AModal: Modal,
  },
  data () {
    return {
      audioResources: {},
      title: '',
      article: '',
      items: [],
      select_word: '',
      frameSrc: '',
      play_last_time: null,
      modal_is_visible: false,
      bodyClickFn: null,
    }
  },
  created () {
    this.init()
  },
  destroyed () {
    document.querySelector('body').removeEventListener('click', this.bodyClickFn)
  },
  mounted () {

  },
  methods: {
    modalClose () {
      this.modal_is_visible = false
      console.log('modalClose')
    },
    alertWordDetail () {
      this.frameSrc = process.env.VUE_APP_API_HOST + '/index/index/searchword?word=' + this.select_word
      this.modal_is_visible = true
      let items = document.querySelectorAll('.left_item .wd.active')
      items.forEach((item, index) => {
        item.classList.remove('active')
      })

    },
    wancheng () {
      this.backRoute()
    },
    to_detail (id) {
      this.$router.push({
        path: '/famous_read/detail',
        query: {
          book_id: id,
        }
      })
    },
    async init () {
      await getFamousChapter({
        id: this.$route.query.book_id,
      }).then((res) => {
        this.items = res.data.list
        this.article = res.data.article

        var getElementPagePosition = function (element) {
          //计算x坐标
          var actualLeft = element.offsetLeft
          var current = element.offsetParent
          while (current !== null) {
            actualLeft += current.offsetLeft
            current = current.offsetParent
          }
          //计算y坐标
          var actualTop = element.offsetTop
          var current = element.offsetParent
          while (current !== null) {
            actualTop += (current.offsetTop + current.clientTop)
            current = current.offsetParent
          }
          return { x: actualLeft, y: actualTop }
        }

        const playFn = (url) => {
          var current_time = (+new Date());
          console.log(current_time<(this.play_last_time + 1000),'fffff');
          if (this.play_last_time && (current_time<(this.play_last_time + 1000))) {
            return false
          }
          this.play_last_time = current_time
          const audio = new Audio()
          audio.preload = true
          audio.controls = false
          audio.src = url
          audio.pause()
          audio.loop = false
          audio.style = 'display:none;'
          document.getElementById('mp3_list').appendChild(audio)
          this.audioResources[url] = audio
          this.audioResources[url].play()
        }
        var playMp3Fn = function () {
          var url = document.querySelector('.js_trans_alert_hd .icon').getAttribute('attr-url')
          playFn(url)
        }
        document.querySelector('.left_item').addEventListener('scroll', function () {
          document.querySelector('.js_trans_alert').style.display = 'none'
        })
        document.querySelector('.js_trans_alert_hd .icon').removeEventListener('click', playMp3Fn)
        document.querySelector('.js_trans_alert_hd .icon').addEventListener('click', playMp3Fn)

        this.bodyClickFn = (e) => {
          let isHide = true
          let isHideWordActive = true
          if (e.path) {
            e.path.forEach((item, index) => {
              if (item.className === 'js_trans_alert') {
                isHide = false
              }
              if (item.className === 'wd') {
                isHideWordActive = false
              }
            })
          }
          if (e.target) {
            console.log(e.target.className)
            if (e.target.className === 'js_trans_alert') {
              isHide = false
            }
            if (e.target.className === 'title') {
              isHide = false
            }
            if (e.target.className === 'js_trans_alert_hd') {
              isHide = false
            }
            if (e.target.className === 'icon') {
              isHide = false
            }
            if (e.target.className === 'ui-btn btn_view_word_detail') {
              isHide = false
            }
            if (e.target.className === 'trans') {
              isHide = false
            }
            if (e.target.className === 'js_trans_alert_bd') {
              isHide = false
            }
            if (e.target.className === 'icon-img') {
              isHide = false
            }
            //end
            if (e.target.className === 'wd active') {
              isHide = false
              isHideWordActive = false
            }
            if (e.target.className === 'wd') {
              isHide = false
              isHideWordActive = false
            }
          }
          if (isHideWordActive) {
            let items = document.querySelectorAll('.left_item .wd.active')
            items.forEach((item, index) => {
              item.classList.remove('active')
            })
          }
          console.log(e, isHide, isHideWordActive)
          if (isHide) {
            document.querySelector('.js_trans_alert').style.display = 'none'
          }
        }
        document.querySelector('body').removeEventListener('click', this.bodyClickFn)
        document.querySelector('body').addEventListener('click', this.bodyClickFn)

        setTimeout(() => {

          var userAgent = navigator.userAgent;
          if (userAgent.indexOf("Firefox") > -1) {
              document.querySelector('.left_item').style.whiteSpace='pre-wrap';
            let items = document.querySelectorAll('.left_item span');
              items.forEach((item,index)=>{
                item.style="display:inline-block";
              });
          }

          let items = document.querySelectorAll('.left_item .wd')
          items.forEach((item, index) => {
            item.addEventListener('click', (e) => {
              document.querySelector('.js_trans_alert').style.display = 'none'
              document.querySelector('.js_trans_alert_hd .icon').style.display = 'block'

              let items = document.querySelectorAll('.left_item .wd.active')
              items.forEach((item, index) => {
                item.classList.remove('active')
              })

              item.classList.add('active')
              var scrollTop = document.querySelector('.left_item').scrollTop
              var position = getElementPagePosition(e.target)
              var top = position.y - scrollTop
              var left = position.x
              var word = e.target.outerText.replace(/[^\w+]/, '')

              searchWord({
                word: word,
              }).then((res) => {
                this.select_word = res.data.select_word
                document.querySelector('.js_trans_alert_hd .title').textContent = res.data.select_word
                document.querySelector('.js_trans_alert_bd .trans').textContent = res.data.translate
                if (res.data.project_voice) {
                  document.querySelector('.js_trans_alert_hd .icon').setAttribute('attr-url', res.data.project_voice)
                  document.querySelector('.js_trans_alert_hd .icon').style.display = 'block'
                } else {
                  document.querySelector('.js_trans_alert_hd .icon').style.display = 'none'
                }
                document.querySelector('.js_trans_alert').style.display = 'block'
                document.querySelector('.js_trans_alert').style.top = top + 'px'

                var subject_height = document.querySelector('.js_trans_alert').clientHeight + 70
                document.querySelector('.js_trans_alert').style.marginTop = '-' + subject_height + 'px'
                document.querySelector('.js_trans_alert').style.left = left + 'px'
                document.querySelector('.js_trans_alert').focus()
              })
            })
          })

        }, 100)
      })
    },
    backRoute () {
      this.$router.back()
    }
  },
}
</script>
<style lang="less">
.items_item{

}
.items_item span{

}

.items_item .js_trans {
  display: inline;
  position: relative;
  .wd {
    cursor: pointer;
  }

  .wd.active {
    color: #27bfa3 !important;
  }
}
</style>
<style lang="less" scoped>
.translate-modal {
  .translate-detail {
    height: 400px;
  }
}

.word_pk_page {
  position: relative;
  display: block;
  height: 100%;
  width: 100%;
}

.js_trans_alert {
  display: none;
  width: 260px;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #27bfa3;
  border-radius: 4px;
  padding: 1rem;

  .js_trans_alert_hd {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
  }

  .icon-img {
    margin-right: 4px;
    cursor: pointer;
    width: 16px;
  }

  .title {
    font-weight: 700;
    font-size: 24px;
    margin-right: .6rem;
    color: #fff;
    word-break: break-all;
  }

  .trans {
    color: #fff;
    margin-top: .5rem;
    margin-bottom: .75rem;
    font-size: 18px;
  }
}

.word_pk_set_words {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-size: 1620px 817px;
  background: url(~assets/lvbg.png) no-repeat center center;
}

.active_color {
  color: #27BF95;
  font-weight: bold;
}

.word_pk_set_words-hd {
  display: flex;
  flex-direction: column;
}

.ui-tab-content {
  display: block;
  height: 100%;
  width: 100%;
}

.navigation {
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: center;
  width: 100%;
  height: 60px;
  text-align: center;
  padding: 0 40px;

  .left {
    flex: 1;
  }

  .center {
    flex: 1;
    font-size: 20px;
    font-weight: bold;
  }

  .right {
    flex: 1;
    display: flex;
    text-align: right;
    align-content: center;
    align-items: center;
    justify-content: flex-end;
  }
}

.word_pk_set_words-bd {
  display: flex;
  flex-direction: column;
  position: relative;
  height: calc(100vh - 80px);
  overflow: auto;
}


.back-btn {
  display: block;
  width: 30px;
  height: 27px;
  background: url(~assets/word/back-icon.png) no-repeat;
  background-size: 100%;
  cursor: pointer;
}

.ui-btn {

  cursor: pointer;
  font-weight: 400;
  display: inline-flex;
  min-width: 80px;
  font-size: 1rem;
  padding: 0.5rem 0.6rem;
  border: 1px solid #ffffff;
  color: #fff;
  border-radius: 4px;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  align-items: center;

  &.ui-btn_primary {
    background: linear-gradient(360deg, #47cbb3 0%, #51d3b0 100%);
    box-shadow: 0 5px 10px rgba(59, 201, 164, 0.03);
    font-size: 14px;
  }

  &.btn_view_word_detail {
    width: 130px;
    text-align: center;
    border: 1px solid #99e2d4 !important;
    color: #8df4e0 !important;
  }
}


.items {
  overflow: auto;
  height: calc(100vh - 80px);
  width: 100%;
  display: flex;
  justify-content: center;

  .items_item {
    width: 50%;
  }

  .items_item_right {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
  }

  .items_item_left {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-end;
  }

  .left_item {
    position: relative;
    margin: 0 20px 0 15%;
    overflow: auto;
    height: calc(100vh - 150px);
    max-height: calc(100vh - 150px);
    padding: 10px;
    background-color: #fff;
    border-radius: 10px;
    font-size: 20px;
    color: #333;
  }

  .right_item {
    position: relative;
    margin: 0 15% 0 0;
    overflow: auto;
    height: calc(100vh - 150px);
    max-height: calc(100vh - 150px);
    padding: 10px;
    background-color: #fff;
    border-radius: 10px;
    font-size: 20px;
    color: #333;
  }
}

.submit-btn {
  display: inline-block;
  min-width: 140px;
  height: 46px;
  line-height: 46px;
  margin-left: .5rem;

  .ui-btn {
    padding: 0;
  }
}

</style>